"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.carousels = void 0;
const splide_1 = __importDefault(require("@splidejs/splide"));
const splide_extension_auto_scroll_1 = require("@splidejs/splide-extension-auto-scroll");
const customArrowPath = 'M20.563,40.563a20,20,0,1,1,20-20A20,20,0,0,1,20.563,40.563Zm2.331-11.581L16.8,23.143H31.53a1.931,1.931,0,0,0,1.935-1.935v-1.29a1.931,1.931,0,0,0-1.935-1.935H16.8l6.089-5.839a1.938,1.938,0,0,0,.032-2.766L22.038,8.5a1.928,1.928,0,0,0-2.734,0L8.6,19.192a1.928,1.928,0,0,0,0,2.734l10.7,10.7a1.927,1.927,0,0,0,2.734,0l.887-.879A1.938,1.938,0,0,0,22.893,28.982Z';
const carousels = () => {
    let logoCarousel = document.getElementsByClassName('logo-carousel');
    for (let i = 0; i < logoCarousel.length; i++) {
        const autoscroll = logoCarousel[i].getAttribute('data-autoscroll') === '1';
        const slidesCount = logoCarousel[i].querySelectorAll('.splide__slide');
        new splide_1.default(logoCarousel[i], {
            perPage: slidesCount.length > 5 ? 5 : slidesCount.length,
            pagination: slidesCount.length > 5,
            type: 'loop',
            arrows: false,
            center: true,
            gap: '1.5rem',
            autoScroll: autoscroll && slidesCount.length > 5 ? {
                speed: 0.8,
            } : false,
            breakpoints: {
                1023: {
                    perPage: 3,
                    pagination: slidesCount.length > 3,
                    autoScroll: autoscroll && slidesCount.length > 3 ? {
                        speed: 0.5,
                    } : false,
                },
                767: {
                    perPage: 2,
                    pagination: slidesCount.length > 2,
                    autoScroll: autoscroll && slidesCount.length > 2 ? {
                        speed: 0.5,
                    } : false,
                },
                519: {
                    perPage: 1,
                    pagination: slidesCount.length > 1,
                    autoScroll: autoscroll && slidesCount.length > 1 ? {
                        speed: 0.5,
                    } : false,
                },
            }
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
    let panelCarousel = document.querySelector('.panel-carousel');
    if (panelCarousel) {
        new splide_1.default(panelCarousel, {
            pagination: false,
            type: 'loop',
            arrows: false,
            autoWidth: true,
            autoScroll: {
                speed: 0.5,
            }
        }).mount({ AutoScroll: splide_extension_auto_scroll_1.AutoScroll });
    }
};
exports.carousels = carousels;
